import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(workflow => ({
        value: workflow.id,
        label: workflow.id_type_alarm,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get('v1/alarm_workflow', { params })

      if (!data) {
        return []
      }

      commit('setData', data.data)
      return data
    },
    async add(_, params) {
      const { data } = await axios.post('v1/alarm_workflow', params)

      return data
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/alarm_workflow/${id}`, params)

      return data
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/alarm_workflow/${id}`)

      return data
    },
    async getUnits(_, id) {
      const { data } = await axios.get('v1/alarm_workflow_unit', { params: { id_alarm_workflow: id, max: 20000 }})

      if (!data) {
        return []
      }

      return data
    },
    async addUnits(_, params) {
      const { data } = await axios.post('v1/alarm_workflow_unit', params)

      return data
    },
    async deleteUnits(_, params) {
      const { data } = await axios.delete(`v1/alarm_workflow_unit`, { data: params })

      return data
    },
    clear({ commit }) {
      commit('setData', [])
    }
  },
}
